export default "__VITE_ASSET__DNcO37Be__"